import React from 'react';

const noop = () => {};

export type LogoAxisProps = {
  className?: string;
  color?: string;
  onClick?: () => void;
};

export const LogoAxis = ({
  className = '',
  color = 'var(--color-main)',
  onClick = noop,
}: LogoAxisProps) => (
  <svg
    className={className}
    viewBox="0 0 57 57"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M2.12132 -1.29342e-05L0 2.12131L54.5611 56.6824L56.6824 54.561L2.12132 -1.29342e-05Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.78045 52.788L1.06055 55.508C3.98975 58.4372 18.3939 48.7812 33.2338 33.9412C48.0738 19.1013 57.7299 4.69711 54.8007 1.76791L52.0807 4.48781C52.0391 4.62061 51.9899 4.76361 51.9342 4.91871C51.3294 6.58151 50.0849 8.88811 48.1889 11.7177C44.4235 17.3337 38.4377 24.4948 31.1125 31.8199C23.7874 39.1451 16.6263 45.1309 11.0103 48.8962C8.18075 50.7922 5.87415 52.0367 4.21135 52.6417L3.96305 52.7284L3.78045 52.788Z"
      fill={color}
    />
    <path
      d="M54.8009 1.7675C51.8716 -1.1618 37.4674 8.4943 22.6275 23.3342C7.78758 38.1741 -1.86853 52.5783 1.06077 55.5076L3.78067 52.7876C3.82237 52.6548 3.87137 52.5119 3.92707 52.3567C4.53197 50.6939 5.77657 48.3874 7.67257 45.5577C11.4379 39.9418 17.4237 32.7807 24.7488 25.4555C32.074 18.1304 39.2351 12.1446 44.8511 8.3792C47.6807 6.4833 49.9873 5.2387 51.65 4.6338C51.8051 4.5782 51.9481 4.5291 52.0809 4.4874L54.8009 1.7675Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="1.06066"
        y1="1.06065"
        x2="55.6219"
        y2="55.6218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color} stopOpacity="0" />
        <stop offset="0.223958" stopColor={color} />
        <stop offset="0.78125" stopColor={color} />
        <stop offset="1" stopColor={color} stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="28.8885"
        y1="17.0732"
        x2="15.8448"
        y2="30.117"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color} />
        <stop offset="0.307292" stopColor={color} stopOpacity="0" />
        <stop offset="0.671875" stopColor={color} stopOpacity="0" />
        <stop offset="1" stopColor={color} />
      </linearGradient>
    </defs>
  </svg>
);